import http from './http'
const base = '/Telas/Conciliacao'
export default {
  async getOptions () { return (await http.get(`${base}/GetOptions`)).data },
  async getImports () { return (await http.get(`${base}/GetImports`)).data },
  async getLines (id) { return (await http.get(`${base}/GetLines/${id}`)).data },
  async getCandidates (id) { return (await http.get(`${base}/GetCandidates/${id}`)).data },
  async importFile (bankAccountId, file) { const data = new FormData(); data.append('bankAccountId', bankAccountId); data.append('file', file); return (await http.post(`${base}/Import`, data)).data },
  async match (lineId, input) { await http.post(`${base}/Match/${lineId}`, input) },
  async ignore (lineId, reason) { await http.post(`${base}/Ignore/${lineId}`, { reason }) }
}
